import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    // Update state to show the fallback UI.
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    // Log the error details for debugging purposes.
    console.error("Error caught by ErrorBoundary:", error);
    console.error("Component stack trace:", errorInfo?.componentStack);

    // Optionally, send the error to a logging service.
    // Example: sendErrorToLoggingService(error, errorInfo);
  }

  render() {
    if (this?.state?.hasError) {
      // Display a fallback UI with error details for developers.
      return (
        <div>
          <h1>Something went wrong.</h1>
          <details style={{ whiteSpace: 'pre-wrap' }}>
            <summary>Error Details</summary>
            <p><strong>Error:</strong> {this.state.error?.toString()}</p>
            <p><strong>Stack Trace:</strong> {this.state.errorInfo?.componentStack}</p>
          </details>
        </div>
      );
    }

    return this?.props?.children;
  }
}

export default ErrorBoundary;